import moment from "moment"
import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect"
import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetWillInvoicedListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    isIncome: boolean
    currentPage: number
    refNo: string
    selectedCustomers: CustomMultiSelectModel[]
    selectedSuppliers: CustomMultiSelectModel[]
    selectedReceiverFirms: CustomMultiSelectModel[]
    orderDateStart: string
    orderDateEnd: string
    loadingDateStart: string
    loadingDateEnd: string
    selectedOrderStatuses: CustomMultiSelectModel[]
    selectedOperationTypes: CustomMultiSelectModel[]
    columnChooser: ColumnChooserModel[] | undefined
    selectedModule: CustomSingleSelectModel | undefined
    /** Panelde çoklu Bölüm (05.10.2026). */
    selectedDivisions: CustomMultiSelectModel[]
    /** Panelde çoklu PO (05.10.2026). */
    selectedPos: CustomMultiSelectModel[]
    /** Virgülle birden fazla PO numarası yazılabilir (05.10.2026). */
    poNo: string | undefined
    /** Aylık sabit gelir siparişlerinin dönemi; doluysa yalnız o dönemin Nakliye siparişleri listelenir (08.10.2026). */
    donemYil?: number
    donemAy?: number
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
}

export const initialGetWillInvoicedListPagingAndFilterRequest: GetWillInvoicedListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    isIncome: true,
    currentPage: 1,
    refNo: '',
    selectedCustomers: [],
    selectedSuppliers: [],
    selectedReceiverFirms: [],
    orderDateStart: moment(new Date()).subtract(1, 'month').format("YYYY-MM-DD"),
    orderDateEnd: moment(new Date()).format("YYYY-MM-DD"),
    loadingDateStart: '',
    loadingDateEnd: '',
    selectedOrderStatuses: [],
    selectedOperationTypes: [],
    columnChooser: undefined,
    selectedModule: undefined,
    selectedDivisions: [],
    selectedPos: [],
    poNo: undefined,
    columnFilters: []
}